import { render, staticRenderFns } from "./CustomContactInfoModal.vue?vue&type=template&id=6ec69fe0"
import script from "./CustomContactInfoModal.vue?vue&type=script&lang=js"
export * from "./CustomContactInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports